/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef, useState} from 'react'
import ApexCharts, {ApexOptions} from 'apexcharts'
import {getCSS, getCSSVariableValue} from "../../../../_metronic/assets/ts/_utils";
import {useThemeMode} from "../../../../_metronic/partials";
import {useQuery} from "react-query";
import {getDashboardChartStats} from "../../../services/statsSvc";
import {ChartPeriods} from "../../../types/stats";
import {translations} from "../../../mock/apexChart";
import {LoaderSection} from "../loader/Loader";

type Props = {
  className?: string
}

const periods: { label: string, key: ChartPeriods }[] = [
  {label: "Kunlik", key: 'daily'},
  {label: "Haftalik", key: 'weekly'},
  {
    label: "Oylik",
    key: 'monthly'
  },
  {label: "Yillik", key: 'yearly'}
]

const ReqStatsSection: React.FC<Props> = ({className}) => {
  const [period, setPeriod] = useState<ChartPeriods>("weekly")
  const chartRef = useRef<HTMLDivElement | null>(null)
  const {
    data: chartStatsData,
    isLoading: chartStatsIsLoading
  } = useQuery(["getDashboardChartStats", period], () => getDashboardChartStats({
    params: {
      distance: period,
      type: "victim"
    }
  }))
  const {mode} = useThemeMode()

  const refreshMode = () => {
    if (!chartRef.current) {
      return
    }

    const height = parseInt(getCSS(chartRef.current, 'height'))

    const chart = new ApexCharts(chartRef.current, getChartOptions(height, chartStatsData))
    if (chart) {
      chart.render()
    }

    return chart
  }

  useEffect(() => {
    const chart = refreshMode()

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [chartRef, mode, chartStatsData, refreshMode])

  return (
      <div className={`card ${className} card-xl-stretch mb-xl-8`}>
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>Murojaatlar statistikasi</span>
            <span className='text-muted fw-semibold fs-7'>
              Xavfli murojaatlar statistikasi
            </span>
          </h3>
          <div className='card-toolbar' data-kt-buttons='true'>
            {
              periods?.map((p, i) => (
                  <button key={i} onClick={() => setPeriod(p.key)}
                          className={`btn btn-sm btn-color-gray-600 btn-active btn-active-primary ${period === p.key ? 'active' : ''}`}>{p.label}</button>
              ))
            }
          </div>
        </div>

        <div className='card-body pt-5'>
          {chartStatsIsLoading ? <LoaderSection height={"30vh"}/> :
              <div ref={chartRef} id='kt_charts_widget_3_chart' style={{height: '350px'}}></div>}
        </div>
      </div>
  )
}

export {ReqStatsSection}

function getChartOptions(height: number, chartStatsData: any): ApexOptions {
  const labelColor = getCSSVariableValue('--bs-gray-500')
  const borderColor = getCSSVariableValue('--bs-gray-200')
  const baseColor = getCSSVariableValue('--bs-danger')
  const lightColor = getCSSVariableValue('--bs-danger-light')

  return {
    series: [
      {
        name: 'Murojaatlar soni',
        data: chartStatsData?.info || [],
      },
    ],
    chart: {
      fontFamily: 'inherit',
      type: 'area',
      height: 350,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {},
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      type: 'solid',
      opacity: 1,
    },
    stroke: {
      curve: 'smooth',
      show: true,
      width: 3,
      colors: [baseColor],
    },
    xaxis: {
      categories: chartStatsData?.labels,
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        formatter(value: string): string | string[] {
          return translations[value] || value
        },
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
      crosshairs: {
        position: 'front',
        stroke: {
          color: baseColor,
          width: 1,
          dashArray: 3,
        },
      },
      tooltip: {
        enabled: true,
        formatter: undefined,
        offsetY: 0,
        style: {
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
    tooltip: {
      style: {
        fontSize: '12px',
      },
      y: {
        formatter: function (val) {
          return val + ' marta'
        },
      },
    },
    colors: [lightColor],
    grid: {
      borderColor: borderColor,
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    markers: {
      strokeColors: baseColor,
      strokeWidth: 3,
    },
  }
}